import React from "react";
import MediaQuery from "react-responsive";
import ReactPlayer from "react-player";
import styled from "styled-components";
//
import { reactPlayerGiffer } from "helpers";
//
export default ({ url }) => {
  if (typeof document === "undefined") {
    return <Wrap />;
  }

  return (
    <MediaQuery minWidth={769}>
      {matches => (
        <Wrap>
          <ReactPlayer
            className="react-player"
            height="100%"
            loop
            muted
            playing={matches}
            width="100%"
            url={reactPlayerGiffer(url)}
          />
        </Wrap>
      )}
    </MediaQuery>
  );
};
//
const Wrap = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;

  .react-player {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;

    video {
      bottom: 0;
      left: 0;
      margin: auto;
      object-fit: cover;
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
    }
  }
`;
